module.exports = __webpack_public_path__ + "static/media/iconmonstr-check-mark-thin.a37d065b.svg";